// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__24VsM","description":"PatientConsentPreview_description__1Cgla"};